import { DashboardRestrictedWordControllerService } from '@api'
import { useMutation } from 'react-query'

import { handleError } from '@/utils/error'

export function useCheckRestrictedWords() {
  const checkMutation = useMutation(
    (message: string) =>
      DashboardRestrictedWordControllerService.checkMessage({
        requestBody: { message },
      }),
    {
      onError: (error) =>
        handleError(error, 'Failed to check restricted words'),
    },
  )

  return {
    checkRestrictedWords: checkMutation.mutateAsync,
    isCheckRestrictedWordsLoading: checkMutation.isLoading,
    checkResponse: checkMutation.data,
    resetCheckMutation: checkMutation.reset,
  }
}
